<template>
  <div class="va-tabs">
    <v-tabs @change="emitValue" v-model="tab" v-bind="$attrs">
      <v-tab v-for="item in items" :key="`tabTitle-${item.tabName}`" :href="'#' + item.tabName">
        <component class="va-tab__icon" v-if="isVue(item.icon)" :is="item.icon"></component>
        <v-icon class="va-tab__icon" v-else-if="item.icon">
          {{ item.icon }}
        </v-icon>
        {{ item.title }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in items" :key="`tabItem-${item.tabName}`" :value="item.tabName">
        <slot :name="item.tabName" :item="item"></slot>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
  export default {
    props: {
      selectedTab: {
        type: String,
        required: true,
        default: "",
      },
      items: {
        type: Array,
        required: true,
        default: () => [],
      },
    },
    data() {
      return {
        tab: null,
      };
    },
    watch: {
      // So that we can change tabs programatically
      selectedTab: {
        handler() {
          this.tab = this.selectedTab;
        },
        immediate: true,
      },
    },
    methods: {
      emitValue(val) {
        this.$emit("change", val);
      },
      // If parameter value is an object, it means it is a vue component instance. Otherwise it's an mdi icon
      isVue(obj) {
        if (typeof obj === "string") return false;

        return true;
      },
    },
  };
</script>
<style></style>
